module.exports = __webpack_public_path__ + "img/流体力学6_2.6096641f.jpg";